export default __webpack_public_path__ + "06fb6b8.png";